import { OrderChannelHelper } from '@biteinc/enums';

import { createLocationGuidedSchema } from './schemas/create_location_guided_schema';

app.NewLocationGuidedDetailsView = app.BaseDetailsView.extend({
  _shouldHideAppearanceDropdown() {
    return app.orgAppearanceList.size() === 1;
  },

  getSchema() {
    const schema = createLocationGuidedSchema;
    if (this._shouldHideAppearanceDropdown()) {
      schema.fields.orgAppearanceId.isHidden = true;
    }
    return schema;
  },

  _save(data, opts, $saveButton) {
    if (this._shouldHideAppearanceDropdown()) {
      app.BaseDetailsView.prototype._save.apply(this, [
        { ...data, orgAppearanceId: app.orgAppearanceList.at(0).id },
        opts,
        $saveButton,
      ]);
    } else {
      app.BaseDetailsView.prototype._save.apply(this, [data, opts, $saveButton]);
    }
  },

  _didSaveModel() {
    app.showSavedToast('Created a New Location!');
    setTimeout(() => {
      window.location.href = `${this.model.bureauUrl()}?create-location-step-by-step=true`;
    }, 1500);
  },

  _setChannelNameBasedOnOrderChannel() {
    const orderChannelFieldView = this.fieldGroupView.fieldViewsByField.orderChannel;
    const channelNameFieldView = this.fieldGroupView.fieldViewsByField.channelName;

    const orderChannel = orderChannelFieldView.getValue();

    if (!orderChannel) {
      // The order channel is required and has a default value, so there should always be a value.
      // If somehow that isn't the case, wipe the field.
      channelNameFieldView.setValue('');
      return;
    }

    const existingChannel = app.locationList.find(
      (existingLocation) =>
        existingLocation.get('siteId') === app.site.id &&
        existingLocation.get('orderChannel') === orderChannel,
    );

    if (existingChannel) {
      // The order channel name must be unique across channels for a given site.
      // If another channel already has the chosen order channel, wipe the field.

      // Arguably we could check if the existing channels are using the default name for that order
      // channel, and if not, use the default instead of an empty string.
      // However, if they're not using the defaults already, then I'd wager they don't plan to for
      // the new channel either; let's save them a few keystrokes.

      channelNameFieldView.setValue('');
    } else {
      channelNameFieldView.setValue(OrderChannelHelper.name(orderChannel));
    }
  },

  render() {
    app.BaseDetailsView.prototype.render.apply(this);

    this.listenTo(
      this.fieldGroupView.fieldViewsByField.orderChannel,
      app.FieldView.Events.FieldDidChangeValue,
      () => {
        this._setChannelNameBasedOnOrderChannel();
      },
    );

    // The order channel field has a default value, so we will have to set the channel name value
    // on render as well as on change.
    this._setChannelNameBasedOnOrderChannel();

    return this;
  },
});
